import { render, staticRenderFns } from "./LeadershipHero.vue?vue&type=template&id=19aaab58&scoped=true&"
import script from "./LeadershipHero.vue?vue&type=script&lang=js&"
export * from "./LeadershipHero.vue?vue&type=script&lang=js&"
import style0 from "./LeadershipHero.vue?vue&type=style&index=0&id=19aaab58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aaab58",
  null
  
)

export default component.exports